import { forwardRef, memo } from "react";
import PropTypes from "prop-types";
import { CircularProgress, Slide, Dialog, Typography, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		background: "transparent",
		color: theme.palette.secondary.main,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const Transition = forwardRef((props, ref) => <Slide ref={ref} direction="up" {...props} />);

const Spinner = ({ open, progressText }) => {
	const classes = useStyles();

	return (
		<Dialog
			fullScreen
			open={open}
			TransitionComponent={Transition}
			maxWidth={false}
			classes={{
				paper: classes.root,
			}}
		>
			<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
				<CircularProgress color="inherit" size={60} />
				{progressText && (
					<Typography variant="h6" sx={{ color: 'inherit', fontWeight: "bold" }}>
						{progressText}
					</Typography>
				)}
			</Box>
		</Dialog>
	);
};

Spinner.propTypes = {
	open: PropTypes.bool.isRequired,
	progressText: PropTypes.string,
};

export default memo(Spinner);
